export default Object.freeze({
  // PERMISSIONS
  CHECK_USER_PERMISSIONS: 'CHECK_USER_PERMISSIONS',

  ADD_NEW_DIRECT_SUCCESS: 'ADD_NEW_DIRECT_SUCCESS',
  ADD_NEW_CARD_SUCCESS: 'ADD_NEW_CARD_SUCCESS',
  // PROFILE
  PROFILE_VALIDITY_DAYS: 1,
  REQUEST_FETCH_PROFILE_DETAILS: 'REQUEST_FETCH_PROFILE_DETAILS',
  RECEIVE_FETCH_PROFILE_DETAILS_SUCCESS:
    'RECEIVE_FETCH_PROFILE_DETAILS_SUCCESS',
  RECEIVE_FETCH_PROFILE_DETAILS_ERROR: 'RECEIVE_FETCH_PROFILE_DETAILS_ERROR',

  // ***********************************************************************************
  // BULK
  SAVE_BULK_DATA: 'SAVE_BULK_DATA',

  // ***********************************************************************************
  // ORDERING
  UPDATE_CATEGORIES_ORDER_REQUEST: 'UPDATE_CATEGORIES_ORDER_REQUEST',
  SET_CATEGORIES_ORDER: 'SET_CATEGORIES_ORDER',
  CLEAR_CATEGORIES_ORDER: 'CLEAR_CATEGORIES_ORDER',

  UPDATE_PRODUCT_ORDER_REQUEST: 'UPDATE_PRODUCT_ORDER_REQUEST',
  SET_PRODUCTS_ORDER: 'SET_PRODUCTS_ORDER',
  CLEAR_PRODUCTS_ORDER: 'CLEAR_PRODUCTS_ORDER',

  // ***********************************************************************************
  // CATEGORIES
  FETCH_CATEGORY_DETAILS_REQUEST: 'FETCH_CATEGORY_DETAILS_REQUEST',
  DELETE_CATEGORY_REQUEST: 'DELETE_CATEGORY_REQUEST',
  DELETE_CATEGORY_SUCCESS: 'DELETE_CATEGORY_SUCCESS',
  DELETE_CATEGORY_ERROR: 'DELETE_CATEGORY_ERROR',

  FETCH_CATEGORIES_REQUEST: 'FETCH_CATEGORIES_REQUEST',
  RECEIVE_CATEGORIES_SUCCESS: 'RECEIVE_CATEGORIES_SUCCESS',
  RECEIVE_CATEGORIES_ERROR: 'RECEIVE_CATEGORIES_ERROR',

  CREATE_CATEGORY_REQUEST: 'CREATE_CATEGORY_REQUEST',
  UPDATE_CATEGORY_DETAILS_REQUEST: 'UPDATE_CATEGORY_DETAILS_REQUEST',
  RECEIVE_CATEGORY_DETAILS_SUCCESS: 'RECEIVE_CATEGORY_DETAILS_SUCCESS',
  RECEIVE_CATEGORY_DETAILS_ERROR: 'RECEIVE_CATEGORY_DETAILS_ERROR',

  RESET_CATEGORY_DETAILS: 'RESET_CATEGORY_DETAILS',

  // ***********************************************************************************
  // EXPORTS
  QUEUE_EXPORT_REQUEST: 'QUEUE_EXPORT_REQUEST',
  QUEUE_EXPORT_SUCCESS: 'QUEUE_EXPORT_SUCCESS',
  QUEUE_EXPORT_ERROR: 'QUEUE_EXPORT_ERROR',

  // ***********************************************************************************
  // FILTERS
  CREATE_FILTER_REQUEST: 'CREATE_FILTER_REQUEST',
  CREATE_FILTER_SUCCESS: 'CREATE_FILTER_SUCCESS',
  CREATE_FILTER_ERROR: 'CREATE_FILTER_ERROR',

  FETCH_FILTER_REQUEST: 'FETCH_FILTER_REQUEST',
  FETCH_FILTER_SUCCESS: 'FETCH_FILTER_SUCCESS',
  FETCH_FILTER_ERROR: 'FETCH_FILTER_ERROR',

  UPDATE_FILTER_REQUEST: 'UPDATE_FILTER_REQUEST',
  UPDATE_FILTER_SUCCESS: 'UPDATE_FILTER_SUCCESS',
  UPDATE_FILTER_ERROR: 'UPDATE_FILTER_ERROR',

  DELETE_FILTER_REQUEST: 'DELETE_FILTER_REQUEST',
  DELETE_FILTER_SUCCESS: 'DELETE_FILTER_SUCCESS',
  DELETE_FILTER_ERROR: 'DELETE_FILTER_ERROR',

  FETCH_FILTERS_REQUEST: 'FETCH_FILTERS_REQUEST',
  FETCH_FILTERS_SUCCESS: 'FETCH_FILTERS_SUCCESS',
  FETCH_FILTERS_ERROR: 'FETCH_FILTERS_ERROR',
  CLEAR_FILTERS: 'CLEAR_FILTERS',
  CLEAR_INVITES: 'CLEAR_INVITES',

  RESET_FILTER_DETAILS: 'RESET_FILTER_DETAILS',

  // ***********************************************************************************
  // FREIGHT GROUPS
  UPDATE_STEP_FREIGHT_GROUP_NEW: 'UPDATE_STEP_FREIGHT_GROUP_NEW',
  SAVE_NAME_FREIGHT_GROUP_NEW: 'SAVE_NAME_FREIGHT_GROUP_NEW',

  // FREIGHT GROUP
  CREATE_FREIGHT_GROUP_REQUEST: 'CREATE_FREIGHT_GROUP_REQUEST',
  CREATE_FREIGHT_GROUP_SUCCESS: 'CREATE_FREIGHT_GROUP_SUCCESS',
  CREATE_FREIGHT_GROUP_FAILURE: 'CREATE_FREIGHT_GROUP_FAILURE',

  REQUEST_SUPPLIER_FREIGHT_GROUPS: 'REQUEST_SUPPLIER_FREIGHT_GROUPS',
  RECEIVE_SUPPLIER_FREIGHT_GROUPS: 'RECEIVE_SUPPLIER_FREIGHT_GROUPS',
  RECEIVE_ERR_SUPPLIER_FREIGHT_GROUPS: 'RECEIVE_ERR_SUPPLIER_FREIGHT_GROUPS',

  REQUEST_DATA_INVITATION_FREIGHT_GROUPS:
    'REQUEST_DATA_INVITATION_FREIGHT_GROUPS',
  RECEIVE_DATA_INVITATION_FREIGHT_GROUPS:
    'RECEIVE_DATA_INVITATION_FREIGHT_GROUPS',

  // V3
  FETCH_FREIGHT_GROUP_DETAILS_REQUEST: 'FETCH_FREIGHT_GROUP_DETAILS_REQUEST',
  RECEIVE_FREIGHT_GROUP_DETAILS_SUCCESS:
    'RECEIVE_FREIGHT_GROUP_DETAILS_SUCCESS',
  RECEIVE_FREIGHT_GROUP_DETAILS_ERROR: 'RECEIVE_FREIGHT_GROUP_DETAILS_ERROR',

  UPDATE_FREIGHT_GROUP_DETAILS_REQUEST: 'UPDATE_FREIGHT_GROUP_DETAILS_REQUEST',
  RECEIVE_UPDATE_FREIGHT_GROUP_DETAILS_SUCCESS:
    'RECEIVE_UPDATE_FREIGHT_GROUP_DETAILS_SUCCESS',
  RECEIVE_UPDATE_FREIGHT_GROUP_DETAILS_ERROR:
    'RECEIVE_UPDATE_FREIGHT_GROUP_DETAILS_ERROR',

  DELETE_FREIGHT_GROUP_REQUEST: 'DELETE_FREIGHT_GROUP_REQUEST',
  RECEIVE_DELETE_FREIGHT_GROUP_SUCCESS: 'RECEIVE_DELETE_FREIGHT_GROUP_SUCCESS',
  RECEIVE_DELETE_FREIGHT_GROUP_ERROR: 'RECEIVE_DELETE_FREIGHT_GROUP_ERROR',

  FETCH_FREIGHT_RETAILERS_REQUEST: 'FETCH_FREIGHT_RETAILERS_REQUEST',
  RECEIVE_FREIGHT_RETAILERS_SUCCESS: 'RECEIVE_FREIGHT_RETAILERS_SUCCESS',
  RECEIVE_FREIGHT_RETAILERS_ERROR: 'RECEIVE_FREIGHT_RETAILERS_ERROR',

  CREATE_FREIGHT_RETAILER_REQUEST: 'CREATE_FREIGHT_RETAILER_REQUEST',
  RECEIVE_CREATE_FREIGHT_RETAILER_SUCCESS:
    'RECEIVE_CREATE_FREIGHT_RETAILER_SUCCESS',
  RECEIVE_CREATE_FREIGHT_RETAILER_ERROR:
    'RECEIVE_CREATE_FREIGHT_RETAILER_ERROR',

  DELETE_FREIGHT_RETAILER_REQUEST: 'DELETE_FREIGHT_RETAILER_REQUEST',
  RECEIVE_DELETE_FREIGHT_RETAILER_SUCCESS:
    'RECEIVE_DELETE_FREIGHT_RETAILER_SUCCESS',
  RECEIVE_DELETE_FREIGHT_RETAILER_ERROR:
    'RECEIVE_DELETE_FREIGHT_RETAILER_ERROR',

  ADD_RETAILER_TO_FREIGHT_GROUP_UI: 'ADD_RETAILER_TO_FREIGHT_GROUP_UI',
  REMOVE_RETAILER_FROM_FREIGHT_GROUP_UI:
    'REMOVE_RETAILER_FROM_FREIGHT_GROUP_UI',
  RESET_DATA_FREIGHT_RETAILERS: 'RESET_DATA_FREIGHT_RETAILERS',
  RESET_EXCLUDED_FREIGHT_RETAILERS: 'RESET_EXCLUDED_FREIGHT_RETAILERS',
  RESET_INCLUDED_FREIGHT_RETAILERS: 'RESET_INCLUDED_FREIGHT_RETAILERS',

  // ***********************************************************************************
  // INTEGRATIONS

  FETCH_INTEGRATIONS_REQUEST: 'FETCH_INTEGRATIONS_REQUEST',
  RECEIVE_INTEGRATIONS_SUCCESS: 'RECEIVE_INTEGRATIONS_SUCCESS',
  RECEIVE_INTEGRATIONS_ERROR: 'RECEIVE_INTEGRATIONS_ERROR',

  DISCONNECT_INTEGRATION_REQUEST: 'DISCONNECT_INTEGRATION_REQUEST',
  RECEIVE_DISCONNECT_INTEGRATION_SUCCESS:
    'RECEIVE_DISCONNECT_INTEGRATION_SUCCESS',
  RECEIVE_DISCONNECT_INTEGRATION_ERROR: 'RECEIVE_DISCONNECT_INTEGRATION_ERROR',

  SYNC_INTEGRATION_REQUEST: 'SYNC_INTEGRATION_REQUEST',
  RECEIVE_SYNC_INTEGRATION_SUCCESS: 'RECEIVE_SYNC_INTEGRATION_SUCCESS',
  RECEIVE_SYNC_INTEGRATION_ERROR: 'RECEIVE_SYNC_INTEGRATION_ERROR',

  // ***********************************************************************************
  // INVITATIONS

  SEND_INVITATION_EMAIL_REQUEST: 'SEND_INVITATION_EMAIL_REQUEST',
  RECEIVE_SEND_INVITATION_EMAIL_SUCCESS:
    'RECEIVE_SEND_INVITATION_EMAIL_SUCCESS',
  RECEIVE_SEND_INVITATION_EMAIL_ERROR: 'RECEIVE_SEND_INVITATION_EMAIL_ERROR',

  // ***********************************************************************************
  // MODAL
  OPEN_MODAL: 'OPEN_MODAL',
  CLOSE_MODAL: 'CLOSE_MODAL',

  // ***********************************************************************************
  // NOTIFICATIONS
  ADD_NOTIFICATION: 'ADD_NOTIFICATION',
  REMOVE_NOTIFICATION: 'REMOVE_NOTIFICATION',
  CLOSE_NOTIFICATIONS: 'CLOSE_NOTIFICATIONS',
  OPEN_NOTIFICATIONS: 'OPEN_NOTIFICATIONS',
  NOTIFICATION_BUTTON: 'NOTIFICATION_BUTTON',
  NOTIFICATION: 'NOTIFICATION',
  MARK_ALL_READ_NOTIFICATIONS: 'MARK_ALL_READ_NOTIFICATIONS',
  VIEW_ALL_NOTIFICATIONS: 'VIEW_ALL_NOTIFICATIONS',
  NOTIFICATION_CLICK: 'NOTIFICATION_CLICK',
  MARK_AS_READ: 'MARK_AS_READ',

  // ***********************************************************************************
  // ORDERS
  REQUEST_ORDERS: 'REQUEST_ORDERS',
  RECEIVE_ORDERS: 'RECEIVE_ORDERS',
  CLEAR_ORDERS: 'CLEAR_ORDERS',
  RECEIVE_ERR_ORDERS: 'RECEIVE_ERR_ORDERS',

  EMAIL_ORDER_REQUEST: 'EMAIL_ORDER_REQUEST',
  EMAIL_ORDER_SUCCESS: 'EMAIL_ORDER_SUCCESS',
  EMAIL_ORDER_ERROR: 'EMAIL_ORDER_ERROR',

  // ***********************************************************************************
  // LIST LOADING

  LIST_LOADING_ON: 'LIST_LOADING_ON',
  LIST_LOADING_OFF: 'LIST_LOADING_OFF',

  // ***********************************************************************************
  // INVOICES
  INVOICE_ACTION_COMPLETED: 'INVOICE_ACTION_COMPLETED',

  BULK_MARK_AS_PAID_REQUEST: 'BULK_MARK_AS_PAID_REQUEST',
  BULK_MARK_AS_PAID_SUCCESS: 'BULK_MARK_AS_PAID_SUCCESS',
  BULK_MARK_AS_PAID_ERROR: 'BULK_MARK_AS_PAID_ERROR',

  EMAIL_INVOICE_REQUEST: 'EMAIL_INVOICE_REQUEST',
  EMAIL_INVOICE_SUCCESS: 'EMAIL_INVOICE_SUCCESS',
  EMAIL_INVOICE_ERROR: 'EMAIL_INVOICE_ERROR',

  // ***********************************************************************************
  // PURCHASER DETAILS
  FETCH_PURCHASER_DETAILS: 'FETCH_PURCHASER_DETAILS',
  FETCH_PURCHASER_DETAILS_PENDING: 'FETCH_PURCHASER_DETAILS_PENDING',
  FETCH_PURCHASER_DETAILS_FULFILLED: 'FETCH_PURCHASER_DETAILS_FULFILLED',
  FETCH_PURCHASER_DETAILS_REJECTED: 'FETCH_PURCHASER_DETAILS_REJECTED',

  // EDIT ORDER DETAILS
  EDIT_ORDER_COMMENT: 'EDIT_ORDER_COMMENT',
  EDIT_ORDER_FREIGHT: 'EDIT_ORDER_FREIGHT',
  EDIT_ORDER_REFERENCE: 'EDIT_ORDER_REFERENCE',
  SET_EDIT_ORDER_VIEW: 'SET_EDIT_ORDER_VIEW',
  UPDATE_TOTAL: 'UPDATE_TOTAL',
  ADD_ORDER_LINE: 'ADD_ORDER_LINE',
  REMOVE_ORDER_LINE: 'REMOVE_ORDER_LINE',
  UPDATE_LINE_QTY: 'UPDATE_LINE_QTY',
  UPDATE_LINE_WEIGHT: 'UPDATE_LINE_WEIGHT',
  UPDATE_LINE_PRICE: 'UPDATE_LINE_PRICE',

  GENERATE_INVOICE_REQUEST: 'GENERATE_INVOICE_REQUEST',
  GENERATE_INVOICE_ERROR: 'GENERATE_INVOICE_ERROR',
  GENERATE_INVOICE_SUCCESS: 'GENERATE_INVOICE_SUCCESS',

  ORDER_DATE_UPDATE_REQUEST: 'ORDER_DATE_UPDATE_REQUEST',
  ORDER_DATE_UPDATE_SUCCESS: 'ORDER_DATE_UPDATE_SUCCESS',
  ORDER_DATE_UPDATE_ERROR: 'ORDER_DATE_UPDATE_ERROR',

  ORDERS_BULK_INVOICE_ERROR: 'ORDERS_BULK_INVOICE_ERROR',
  ORDERS_BULK_INVOICE_SUCCESS: 'ORDERS_BULK_INVOICE_SUCCESS',
  ORDERS_BULK_INVOICE_PENDING: 'ORDERS_BULK_INVOICE_PENDING',

  ORDERS_BULK_UPDATE_REQUEST: 'ORDERS_BULK_UPDATE_REQUEST',
  ORDERS_BULK_UPDATE_SUCCESS: 'ORDERS_BULK_UPDATE_SUCCESS',
  ORDERS_BULK_UPDATE_ERROR: 'ORDERS_BULK_UPDATE_REQUEST',

  // ***********************************************************************************
  // PAYMENT METHODS
  CREATE_PAYMENT_METHOD_REQUEST: 'CREATE_PAYMENT_METHOD_REQUEST',
  CREATE_PAYMENT_METHOD_SUCCESS: 'CREATE_PAYMENT_METHOD_SUCCESS',
  CREATE_PAYMENT_METHOD_ERROR: 'CREATE_PAYMENT_METHOD_ERROR',
  DELETE_PAYMENT_METHOD_REQUEST: 'DELETE_PAYMENT_METHOD_REQUEST',
  DELETE_PAYMENT_METHOD_SUCCESS: 'DELETE_PAYMENT_METHOD_SUCCESS',
  DELETE_PAYMENT_METHOD_ERROR: 'DELETE_PAYMENT_METHOD_ERROR',
  DELETE_DEFAULT_PAYMENT_METHOD_REQUEST:
    'DELETE_DEFAULT_PAYMENT_METHOD_REQUEST',
  DELETE_DEFAULT_PAYMENT_METHOD_SUCCESS:
    'DELETE_DEFAULT_PAYMENT_METHOD_SUCCESS',
  DELETE_DEFAULT_PAYMENT_METHOD_ERROR: 'DELETE_DEFAULT_PAYMENT_METHOD_ERROR',
  CLEAR_PURCHASER_DETAILS: 'CLEAR_PURCHASER_DETAILS',
  DEBIT_CREDIT_CARD_SAVE_CLICKED: 'DEBIT_CREDIT_CARD_SAVE_CLICKED',

  VALIDATE_CARD: 'VALIDATE_CARD',
  VALIDATE_CARD_PENDING: 'VALIDATE_CARD_PENDING',
  VALIDATE_CARD_FULFILLED: 'VALIDATE_CARD_FULFILLED',
  VALIDATE_CARD_REJECTED: 'VALIDATE_CARD_REJECTED',

  GET_CARD_TYPE: 'GET_CARD_TYPE',
  GET_CARD_TYPE_PENDING: 'GET_CARD_TYPE_PENDING',
  GET_CARD_TYPE_FULFILLED: 'GET_CARD_TYPE_FULFILLED',
  GET_CARD_TYPE_REJECTED: 'GET_CARD_TYPE_REJECTED',
  CLEAR_CARD_VALIDATIONS: 'CLEAR_CARD_VALIDATIONS',

  ADD_NEW_CARD: 'ADD_NEW_CARD',
  ADD_NEW_CARD_PENDING: 'ADD_NEW_CARD_PENDING',
  ADD_NEW_CARD_FULFILLED: 'ADD_NEW_CARD_FULFILLED',
  ADD_NEW_CARD_REJECTED: 'ADD_NEW_CARD_REJECTED',
  NOTIFY_ADD_NEW_CARD_SUCCESS: 'NOTIFY_ADD_NEW_CARD_SUCCESS',
  NOTIFY_ADD_NEW_CARD_FAILURE: 'NOTIFY_ADD_NEW_CARD_FAILURE',

  ADD_NEW_DIRECT_DEBIT: 'ADD_NEW_DIRECT_DEBIT',
  ADD_NEW_DIRECT_DEBIT_PENDING: 'ADD_NEW_DIRECT_DEBIT_PENDING',
  ADD_NEW_DIRECT_DEBIT_FULFILLED: 'ADD_NEW_DIRECT_DEBIT_FULFILLED',
  ADD_NEW_DIRECT_DEBIT_REJECTED: 'ADD_NEW_DIRECT_DEBIT_REJECTED',
  NOTIFY_ADD_NEW_DIRECT_SUCCESS: 'NOTIFY_ADD_NEW_DIRECT_SUCCESS',
  NOTIFY_ADD_NEW_DIRECT_FAILURE: 'NOTIFY_ADD_NEW_DIRECT_FAILURE',

  FETCH_PAYMENT_DETAILS: 'FETCH_PAYMENT_DETAILS',
  FETCH_PAYMENT_DETAILS_PENDING: 'FETCH_PAYMENT_DETAILS_PENDING',
  FETCH_PAYMENT_DETAILS_FULFILLED: 'FETCH_PAYMENT_DETAILS_FULFILLED',
  FETCH_PAYMENT_DETAILS_REJECTED: 'FETCH_PAYMENT_DETAILS_REJECTED',

  FETCH_PAYMENT_METHOD_DETAILS: 'FETCH_PAYMENT_METHOD_DETAILS',
  FETCH_PAYMENT_METHOD_DETAILS_PENDING: 'FETCH_PAYMENT_METHOD_DETAILS_PENDING',
  FETCH_PAYMENT_METHOD_DETAILS_FULFILLED:
    'FETCH_PAYMENT_METHOD_DETAILS_FULFILLED',
  FETCH_PAYMENT_METHOD_DETAILS_REJECTED:
    'FETCH_PAYMENT_METHOD_DETAILS_REJECTED',

  FETCH_PAYMENT_METHODS: 'FETCH_PAYMENT_METHODS',
  FETCH_PAYMENT_METHODS_PENDING: 'FETCH_PAYMENT_METHODS_PENDING',
  FETCH_PAYMENT_METHODS_FULFILLED: 'FETCH_PAYMENT_METHODS_FULFILLED',
  FETCH_PAYMENT_METHODS_REJECTED: 'FETCH_PAYMENT_METHODS_REJECTED',
  NOTIFY_TOGGLE_DEFAULT_PAYMENT_FULFILLED:
    'NOTIFY_TOGGLE_DEFAULT_PAYMENT_FULFILLED',
  NOTIFY_TOGGLE_DEFAULT_PAYMENT_REJECTED:
    'NOTIFY_TOGGLE_DEFAULT_PAYMENT_FULFILLED',

  FETCH_PAYMENTS: 'FETCH_PAYMENTS',
  FETCH_PAYMENTS_PENDING: 'FETCH_PAYMENTS_PENDING',
  FETCH_PAYMENTS_FULFILLED: 'FETCH_PAYMENTS_FULFILLED',
  FETCH_PAYMENTS_REJECTED: 'FETCH_PAYMENTS_REJECTED',

  TOGGLE_DEFAULT_PAYMENT_SUCCESS: 'TOGGLE_DEFAULT_PAYMENT_SUCCESS',
  TOGGLE_DEFAULT_PAYMENT_FAILURE: 'TOGGLE_DEFAULT_PAYMENT_FAILURE',

  DELETE_PAYMENT_METHOD: 'DELETE_PAYMENT_METHOD',
  DELETE_PAYMENT_METHOD_PENDING: 'DELETE_PAYMENT_METHOD_PENDING',
  DELETE_PAYMENT_METHOD_FAILURE: 'DELETE_PAYMENT_METHOD_FAILURE',
  NOTIFY_DELETE_PAYMENT_METHOD_SUCCESS: 'NOTIFY_DELETE_PAYMENT_METHOD_SUCCESS',
  NOTIFY_DELETE_PAYMENT_METHOD_FAILURE: 'NOTIFY_DELETE_PAYMENT_METHOD_FAILURE',

  // PRICING GROUP
  CREATE_PRICE_GROUP_REQUEST: 'CREATE_PRICE_GROUP_REQUEST',
  CREATE_PRICE_GROUP_SUCCESS: 'CREATE_PRICE_GROUP_SUCCESS',
  CREATE_PRICE_GROUP_FAILURE: 'CREATE_PRICE_GROUP_FAILURE',

  FETCH_PRICING_GROUP_DETAILS_REQUEST: 'FETCH_PRICING_GROUP_DETAILS_REQUEST',
  RECEIVE_PRICING_GROUP_DETAILS_SUCCESS:
    'RECEIVE_PRICING_GROUP_DETAILS_SUCCESS',
  RECEIVE_PRICING_GROUP_DETAILS_ERROR: 'RECEIVE_PRICING_GROUP_DETAILS_ERROR',

  UPDATE_PRICING_GROUP_DETAILS_REQUEST: 'UPDATE_PRICING_GROUP_DETAILS_REQUEST',
  RECEIVE_UPDATE_PRICING_GROUP_DETAILS_SUCCESS:
    'RECEIVE_UPDATE_PRICING_GROUP_DETAILS_SUCCESS',
  RECEIVE_UPDATE_PRICING_GROUP_DETAILS_ERROR:
    'RECEIVE_UPDATE_PRICING_GROUP_DETAILS_ERROR',

  // PRICE GROUPS
  REQUEST_INVITATION_PRICE_GROUPS: 'REQUEST_INVITATION_PRICE_GROUPS',
  RECEIVE_DATA_INVITATION_PRICE_GROUPS: 'RECEIVE_DATA_INVITATION_PRICE_GROUPS',

  REQUEST_SUPPLIER_PRICE_GROUPS: 'REQUEST_SUPPLIER_PRICE_GROUPS',
  RECEIVE_SUPPLIER_PRICE_GROUPS: 'RECEIVE_SUPPLIER_PRICE_GROUPS',
  RECEIVE_SUPPLIER_PRICE_GROUPS_PAGINATED:
    'RECEIVE_SUPPLIER_PRICE_GROUPS_PAGINATED',
  RECEIVE_ERR_SUPPLIER_PRICE_GROUPS: 'RECEIVE_ERR_SUPPLIER_PRICE_GROUPS',

  // V3
  FETCH_PRICING_RETAILERS_REQUEST: 'FETCH_PRICING_RETAILERS_REQUEST',
  RECEIVE_PRICING_RETAILERS_SUCCESS: 'RECEIVE_PRICING_RETAILERS_SUCCESS',
  RECEIVE_PRICING_RETAILERS_ERROR: 'RECEIVE_PRICING_RETAILERS_ERROR',

  CREATE_PRICING_RETAILER_REQUEST: 'CREATE_PRICING_RETAILER_REQUEST',
  RECEIVE_CREATE_PRICING_RETAILER_SUCCESS:
    'RECEIVE_CREATE_PRICING_RETAILER_SUCCESS',
  RECEIVE_CREATE_PRICING_RETAILER_ERROR:
    'RECEIVE_CREATE_PRICING_RETAILER_ERROR',

  DELETE_PRICING_RETAILER_REQUEST: 'DELETE_PRICING_RETAILER_REQUEST',
  RECEIVE_DELETE_PRICING_RETAILER_SUCCESS:
    'RECEIVE_DELETE_PRICING_RETAILER_SUCCESS',
  RECEIVE_DELETE_PRICING_RETAILER_ERROR:
    'RECEIVE_DELETE_PRICING_RETAILER_ERROR',

  ADD_RETAILER_TO_PRICING_GROUP_UI: 'ADD_RETAILER_TO_PRICING_GROUP_UI',
  REMOVE_RETAILER_FROM_PRICING_GROUP_UI:
    'REMOVE_RETAILER_FROM_PRICING_GROUP_UI',
  RESET_DATA_PRICING_RETAILERS: 'RESET_DATA_PRICING_RETAILERS',
  RESET_EXCLUDED_PRICING_RETAILERS: 'RESET_EXCLUDED_PRICING_RETAILERS',
  RESET_INCLUDED_PRICING_RETAILERS: 'RESET_INCLUDED_PRICING_RETAILERS',

  UPDATE_PRICING_PRODUCTS_REQUEST: 'UPDATE_PRICING_PRODUCTS_REQUEST',
  RECEIVE_UPDATE_PRICING_PRODUCTS_SUCCESS:
    'RECEIVE_UPDATE_PRICING_PRODUCTS_SUCCESS',
  RECEIVE_UPDATE_PRICING_PRODUCTS_ERROR:
    'RECEIVE_UPDATE_PRICING_PRODUCTS_ERROR',

  DELETE_PRICING_GROUP_REQUEST: 'DELETE_PRICING_GROUP_REQUEST',
  RECEIVE_DELETE_PRICING_GROUP_SUCCESS: 'RECEIVE_DELETE_PRICING_GROUP_SUCCESS',
  RECEIVE_DELETE_PRICING_GROUP_ERROR: 'RECEIVE_DELETE_PRICING_GROUP_ERROR',

  // ***********************************************************************************
  // PRODUCTS
  FETCH_PRODUCTS_REQUEST: 'FETCH_PRODUCTS_REQUEST',

  RECEIVE_PRODUCTS_SUCCESS: 'RECEIVE_PRODUCTS_SUCCESS',
  RECEIVE_PRODUCTS_ERROR: 'RECEIVE_PRODUCTS_ERROR',

  SET_PRODUCTS_FILTER: 'SET_PRODUCTS_FILTER',

  DELETE_PRODUCT_REQUEST: 'DELETE_PRODUCT_REQUEST',
  DELETE_PRODUCT_SUCCESS: 'DELETE_PRODUCT_SUCCESS',
  DELETE_PRODUCT_ERROR: 'DELETE_PRODUCT_ERROR',

  PRODUCTS_BULK_DELETE_REQUEST: 'PRODUCTS_BULK_DELETE_REQUEST',
  PRODUCTS_BULK_DELETE_SUCCESS: 'PRODUCTS_BULK_DELETE_SUCCESS',
  PRODUCTS_BULK_DELETE_ERROR: 'PRODUCTS_BULK_DELETE_REQUEST',

  PRODUCTS_BULK_UPDATE_REQUEST: 'PRODUCTS_BULK_UPDATE_REQUEST',
  PRODUCTS_BULK_UPDATE_SUCCESS: 'PRODUCTS_BULK_UPDATE_SUCCESS',
  PRODUCTS_BULK_UPDATE_ERROR: 'PRODUCTS_BULK_UPDATE_ERROR',

  // PRODUCT
  FETCH_PRODUCT_DETAILS_REQUEST: 'FETCH_PRODUCT_DETAILS_REQUEST',
  UPDATE_PRODUCT_DETAILS_REQUEST: 'UPDATE_PRODUCT_DETAILS_REQUEST',
  CREATE_PRODUCT_REQUEST: 'CREATE_PRODUCT_REQUEST',
  RESET_PRODUCT_DETAILS: 'RESET_PRODUCT_DETAILS',

  RECEIVE_PRODUCT_DETAILS_SUCCESS: 'RECEIVE_PRODUCT_DETAILS_SUCCESS',
  RECEIVE_PRODUCT_DETAILS_ERROR: 'RECEIVE_PRODUCT_DETAILS_ERROR',

  REQUEST_PRODUCT_DETAILS_SAGA: 'REQUEST_PRODUCT_DETAILS_SAGA',
  REQUEST_PRODUCT_DETAILS: 'REQUEST_PRODUCT_DETAILS',
  RECEIVE_PRODUCT_DETAILS: 'RECEIVE_PRODUCT_DETAILS',
  RECEIVE_ERROR_PRODUCT_DETAILS: 'RECEIVE_ERROR_PRODUCT_DETAILS',
  RECEIVE_PRODUCT_DISPLAY_PRICE_CALCULATE_SUCCESS:
    'RECEIVE_PRODUCT_DISPLAY_PRICE_CALCULATE_SUCCESS',
  RECEIVE_PRODUCT_DISPLAY_PRICE_CALCULATE_ERROR:
    'RECEIVE_PRODUCT_DISPLAY_PRICE_CALCULATE_ERROR',
  RECEIVE_PRODUCT_DISPLAY_PRICE_CALCULATE_SAGA:
    'RECEIVE_PRODUCT_DISPLAY_PRICE_CALCULATE_SAGA',
  REQUEST_VISIBILITY_GROUPS_SAGA: 'REQUEST_VISIBILITY_GROUPS_SAGA',
  REQUEST_CATEGORIES_SAGA: 'REQUEST_CATEGORIES_SAGA',
  REQUEST_CREATE_PRODUCT_DETAILS_SAGA: 'REQUEST_CREATE_PRODUCT_DETAILS_SAGA',
  REQUEST_UPDATE_PRODUCT_DETAILS_SAGA: 'REQUEST_UPDATE_PRODUCT_DETAILS_SAGA',
  REQUEST_DELETE_PRODUCT_SAGA: 'REQUEST_DELETE_PRODUCT_SAGA',
  RESET_PRODUCT_DETAILS_SAGA: 'RESET_PRODUCT_DETAILS_SAGA',

  FETCH_IMAGES_REQUEST: 'FETCH_IMAGES_REQUEST',
  FETCH_IMAGES_SUCCESS: 'FETCH_IMAGES_SUCCESS',
  FETCH_IMAGES_FAILURE: 'FETCH_IMAGES_FAILURE',
  FETCH_IMAGES_SAGA: 'FETCH_IMAGES_SAGA',
  // uom
  FETCH_UOM_REQUEST: 'FETCH_UOM_REQUEST',
  RECEIVE_UOM_SUCCESS: 'RECEIVE_UOM_SUCCESS',
  RECEIVE_UOM_ERROR: 'RECEIVE_UOM_ERROR',

  // Variants
  NOTIFY_CREATE_VARIANT_ERROR: 'NOTIFY_CREATE_VARIANT_ERROR',
  NOTIFY_UPDATE_VARIANT_ERROR: 'NOTIFY_UPDATE_VARIANT_ERROR',

  // VISIBILITY PRODUCT

  //--
  CREATE_VISIBILITY_PRODUCT_SUCCESS: 'CREATE_VISIBILITY_PRODUCT_SUCCESS',
  CREATE_VISIBILITY_PRODUCT_FAILURE: 'CREATE_VISIBILITY_PRODUCT_FAILURE',

  DELETE_VISIBILITY_PRODUCT_SUCCESS: 'DELETE_VISIBILITY_PRODUCT_SUCCESS',
  DELETE_VISIBILITY_PRODUCT_FAILURE: 'DELETE_VISIBILITY_PRODUCT_FAILURE',

  ADD_PRODUCTS_TO_VISIBILITY_REQUEST: 'ADD_PRODUCTS_TO_VISIBILITY_REQUEST',
  ADD_PRODUCTS_TO_VISIBILITY_SUCCESS: 'ADD_PRODUCTS_TO_VISIBILITY_SUCCESS',
  ADD_PRODUCTS_TO_VISIBILITY_FAILURE: 'ADD_PRODUCTS_TO_VISIBILITY_FAILURE',
  //--

  REMOVE_PRODUCTS_FROM_VISIBILITY_GROUP_REQUEST:
    'REMOVE_PRODUCTS_FROM_VISIBILITY_GROUP_REQUEST',
  RECEIVE_REMOVE_PRODUCTS_FROM_VISIBILITY_GROUP_SUCCESS:
    'RECEIVE_REMOVE_PRODUCTS_FROM_VISIBILITY_GROUP_SUCCESS',
  RECEIVE_REMOVE_PRODUCTS_FROM_VISIBILITY_GROUP_ERROR:
    'RECEIVE_REMOVE_PRODUCTS_FROM_VISIBILITY_GROUP_ERROR',

  // VISIBILITY GROUP PRODUCTS
  REQUEST_VISIBILITY_PRODUCTS: 'REQUEST_VISIBILITY_PRODUCTS',
  RECEIVE_VISIBILITY_PRODUCTS: 'RECEIVE_VISIBILITY_PRODUCTS',
  RECEIVE_ERR_VISIBILITY_PRODUCTS: 'RECEIVE_ERR_VISIBILITY_PRODUCTS',

  // VISIBILITY GROUP PRODUCTS V3
  FETCH_VISIBILITY_PRODUCTS_REQUEST: 'FETCH_VISIBILITY_PRODUCTS_REQUEST',
  RECEIVE_VISIBILITY_PRODUCTS_SUCCESS: 'RECEIVE_VISIBILITY_PRODUCTS_SUCCESS',
  RECEIVE_VISIBILITY_PRODUCTS_ERROR: 'RECEIVE_VISIBILITY_PRODUCTS_ERROR',

  // .. create join
  CREATE_VISIBILITY_PRODUCT_REQUEST: 'CREATE_VISIBILITY_PRODUCT_REQUEST',
  RECEIVE_CREATE_VISIBILITY_PRODUCT_SUCCESS:
    'RECEIVE_CREATE_VISIBILITY_PRODUCT_SUCCESS',
  RECEIVE_CREATE_VISIBILITY_PRODUCT_ERROR:
    'RECEIVE_CREATE_VISIBILITY_PRODUCT_ERROR',

  BULK_CREATE_VISIBILITY_PRODUCT_REQUEST:
    'BULK_CREATE_VISIBILITY_PRODUCT_REQUEST',
  RECEIVE_BULK_CREATE_VISIBILITY_PRODUCT_SUCCESS:
    'RECEIVE_BULK_CREATE_VISIBILITY_PRODUCT_SUCCESS',
  RECEIVE_BULK_CREATE_VISIBILITY_PRODUCT_ERROR:
    'RECEIVE_BULK_CREATE_VISIBILITY_PRODUCT_ERROR',

  // .. delete join
  DELETE_VISIBILITY_PRODUCT_REQUEST: 'DELETE_VISIBILITY_PRODUCT_REQUEST',
  RECEIVE_DELETE_VISIBILITY_PRODUCT_SUCCESS:
    'RECEIVE_DELETE_VISIBILITY_PRODUCT_SUCCESS',
  RECEIVE_DELETE_VISIBILITY_PRODUCT_ERROR:
    'RECEIVE_DELETE_VISIBILITY_PRODUCT_ERROR',

  BULK_DELETE_VISIBILITY_PRODUCT_REQUEST:
    'BULK_DELETE_VISIBILITY_PRODUCT_REQUEST',
  RECEIVE_BULK_DELETE_VISIBILITY_PRODUCT_SUCCESS:
    'RECEIVE_BULK_DELETE_VISIBILITY_PRODUCT_SUCCESS',
  RECEIVE_BULK_DELETE_VISIBILITY_PRODUCT_ERROR:
    'RECEIVE_BULK_DELETE_VISIBILITY_PRODUCT_ERROR',

  // .. other
  UPDATE_VISIBILITY_PRODUCTS_REQUEST: 'UPDATE_VISIBILITY_PRODUCTS_REQUEST',

  CREATE_PURCHASER_REQUEST: 'CREATE_PURCHASER_REQUEST',
  CREATE_PURCHASER_SUCCESS: 'CREATE_PURCHASER_SUCCESS',
  CREATE_PURCHASER_FAILURE: 'CREATE_PURCHASER_FAILURE',

  // PURCHASERS
  REQUEST_PURCHASERS: 'REQUEST_PURCHASERS',
  RECEIVE_PURCHASERS: 'RECEIVE_PURCHASERS',
  CLEAR_PURCHASERS: 'CLEAR_PURCHASERS',
  RECEIVE_ERR_PURCHASERS: 'RECEIVE_ERR_PURCHASERS',

  // ***********************************************************************************
  // RETAILERS
  CREATE_RETAILER_REQUEST: 'CREATE_RETAILER_REQUEST',
  CREATE_RETAILER_SUCCESS: 'CREATE_RETAILER_SUCCESS',
  CREATE_RETAILER_FAILURE: 'CREATE_RETAILER_FAILURE',

  BULK_DELETE_RETAILERS_REQUEST: 'BULK_DELETE_RETAILERS_REQUEST',
  BULK_DELETE_RETAILERS_SUCCESS: 'BULK_DELETE_RETAILERS_SUCCESS',
  BULK_DELETE_RETAILERS_ERROR: 'BULK_DELETE_RETAILERS_ERROR',

  // ORDER ON BEHALF
  ORDER_ON_BEHALF: 'ORDER_ON_BEHALF',

  // RETAILERS
  REQUEST_RETAILERS: 'REQUEST_RETAILERS',
  RECEIVE_RETAILERS: 'RECEIVE_RETAILERS',
  RECEIVE_ERR_RETAILERS: 'RECEIVE_ERR_RETAILERS',
  REQUEST_RETAILER_DETAILS: 'REQUEST_RETAILER_DETAILS',
  UPDATE_RETAILER_DETAILS_UI: 'UPDATE_RETAILER_DETAILS_UI',
  RECEIVE_RETAILER_DETAILS: 'RECEIVE_RETAILER_DETAILS',
  RECEIVE_ERR_RETAILER_DETAILS: 'RECEIVE_ERR_RETAILER_DETAILS',
  REQUEST_RETAILER_PAYMENT_DETAILS: 'REQUEST_RETAILER_PAYMENT_DETAILS',
  RECEIVE_RETAILER_PAYMENT_DETAILS: 'RECEIVE_RETAILER_PAYMENT_DETAILS',
  RECEIVE_ERR_RETAILER_PAYMENT_DETAILS: 'RECEIVE_ERR_RETAILER_PAYMENT_DETAILS',
  REQUEST_RETAILER_PURCHASER_DETAILS: 'REQUEST_RETAILER_PURCHASER_DETAILS',
  RECEIVE_RETAILER_PURCHASER_DETAILS: 'RECEIVE_RETAILER_PURCHASER_DETAILS',
  RECEIVE_ERR_RETAILER_PURCHASER_DETAILS:
    'RECEIVE_ERR_RETAILER_PURCHASER_DETAILS',
  REQUEST_INVOICE_PAYMENT: 'request_invoice_payment',

  // VISIBILITY GROUP RETAILERS V3
  FETCH_VISIBILITY_RETAILERS_REQUEST: 'FETCH_VISIBILITY_RETAILERS_REQUEST',
  RECEIVE_VISIBILITY_RETAILERS_SUCCESS: 'RECEIVE_VISIBILITY_RETAILERS_SUCCESS',
  RECEIVE_VISIBILITY_RETAILERS_ERROR: 'RECEIVE_VISIBILITY_RETAILERS_ERROR',
  SAVE_VISIBILITY_RETAILERS_IDS: 'SAVE_VISIBILITY_RETAILERS_IDS',

  CREATE_VISIBILITY_RETAILER_REQUEST: 'CREATE_VISIBILITY_RETAILER_REQUEST',
  RECEIVE_CREATE_VISIBILITY_RETAILER_SUCCESS:
    'RECEIVE_CREATE_VISIBILITY_RETAILER_SUCCESS',
  RECEIVE_CREATE_VISIBILITY_RETAILER_ERROR:
    'RECEIVE_CREATE_VISIBILITY_RETAILER_ERROR',

  DELETE_VISIBILITY_RETAILER_REQUEST: 'DELETE_VISIBILITY_RETAILER_REQUEST',
  RECEIVE_DELETE_VISIBILITY_RETAILER_SUCCESS:
    'RECEIVE_DELETE_VISIBILITY_RETAILER_SUCCESS',
  RECEIVE_DELETE_VISIBILITY_RETAILER_ERROR:
    'RECEIVE_DELETE_VISIBILITY_RETAILER_ERROR',

  ADD_RETAILER_TO_VISIBILITY_GROUP_UI: 'ADD_RETAILER_TO_VISIBILITY_GROUP_UI',
  REMOVE_RETAILER_FROM_VISIBILITY_GROUP_UI:
    'REMOVE_RETAILER_FROM_VISIBILITY_GROUP_UI',

  ADD_RETAILER_TO_VISIBILITY_GROUP_QUEUE:
    'ADD_RETAILER_TO_VISIBILITY_GROUP_QUEUE',
  REMOVE_RETAILER_FROM_VISIBILITY_GROUP_QUEUE:
    'REMOVE_RETAILER_FROM_VISIBILITY_GROUP_QUEUE',
  RESET_DATA_VISIBILITY_RETAILERS: 'RESET_DATA_VISIBILITY_RETAILERS',
  RESET_EXCLUDED_VISIBILITY_RETAILERS: 'RESET_EXCLUDED_VISIBILITY_RETAILERS',
  RESET_INCLUDED_VISIBILITY_RETAILERS: 'RESET_INCLUDED_VISIBILITY_RETAILERS',

  UPDATE_ORDER_PROJECTIONS_START_OF_WEEK:
    'UPDATE_ORDER_PROJECTIONS_START_OF_WEEK',

  ADD_LINE_ITEM_TO_PROJECTIONS: 'ADD_LINE_ITEM_TO_PROJECTIONS',

  FETCH_ORDER_PROJECTIONS_REQUEST: 'FETCH_ORDER_PROJECTIONS_REQUEST',
  FETCH_ORDER_PROJECTIONS_SUCCESS: 'FETCH_ORDER_PROJECTIONS_SUCCESS',
  FETCH_ORDER_PROJECTIONS_ERROR: 'FETCH_ORDER_PROJECTIONS_ERROR',

  FETCH_ORDERS_FROM_PROJECTIONS_REQUEST:
    'FETCH_ORDERS_FROM_PROJECTIONS_REQUEST',
  FETCH_ORDERS_FROM_PROJECTIONS_SUCCESS:
    'FETCH_ORDERS_FROM_PROJECTIONS_SUCCESS',
  FETCH_ORDERS_FROM_PROJECTIONS_ERROR: 'FETCH_ORDERS_FROM_PROJECTIONS_ERROR',

  CREATE_SCHEDULE_REQUEST: 'CREATE_SCHEDULE_REQUEST',
  CREATE_SCHEDULE_SUCCESS: 'CREATE_SCHEDULE_SUCCESS',
  CREATE_SCHEDULE_FAILURE: 'CREATE_SCHEDULE_FAILURE',

  RESET_DATA_SCHEDULE_DETAILS: 'RESET_DATA_SCHEDULE_DETAILS',

  UPDATE_SCHEDULE_REQUEST: 'UPDATE_SCHEDULE_REQUEST',
  UPDATE_SCHEDULE_SUCCESS: 'UPDATE_SCHEDULE_SUCCESS',
  UPDATE_SCHEDULE_FAILURE: 'UPDATE_SCHEDULE_FAILURE',

  DELETE_SCHEDULE_REQUEST: 'DELETE_SCHEDULE_REQUEST',
  RECEIVE_DELETE_SCHEDULE_SUCCESS: 'RECEIVE_DELETE_SCHEDULE_SUCCESS',
  RECEIVE_DELETE_SCHEDULE_ERROR: 'RECEIVE_DELETE_SCHEDULE_ERROR',

  // ***********************************************************************************
  // SUPPLIER
  FETCH_SUPPLIER_DETAILS_REQUEST: 'FETCH_SUPPLIER_DETAILS_REQUEST',
  FETCH_SUPPLIER_DETAILS_SUCCESS: 'FETCH_SUPPLIER_DETAILS_SUCCESS',
  FETCH_SUPPLIER_DETAILS_FAILURE: 'FETCH_SUPPLIER_DETAILS_FAILURE',

  UPDATE_SUPPLIER_DETAILS_REQUEST: 'UPDATE_SUPPLIER_DETAILS_REQUEST',
  UPDATE_SUPPLIER_DETAILS_SUCCESS: 'UPDATE_SUPPLIER_DETAILS_SUCCESS',
  UPDATE_SUPPLIER_DETAILS_FAILURE: 'UPDATE_SUPPLIER_DETAILS_FAILURE',

  REQUEST_UPLOAD_SUPPLIER_IMAGE: 'REQUEST_UPLOAD_SUPPLIER_IMAGE',
  RECEIVE_UPLOAD_SUPPLIER_IMAGE_SUCCESS:
    'RECEIVE_UPLOAD_SUPPLIER_IMAGE_SUCCESS',
  RECEIVE_UPLOAD_SUPPLIER_IMAGE_ERROR: 'RECEIVE_UPLOAD_SUPPLIER_IMAGE_ERROR',

  // ***********************************************************************************
  // USERS
  REQUEST_RETAILER_USERS: 'REQUEST_RETAILER_USERS',
  RECEIVE_RETAILER_USERS: 'RECEIVE_RETAILER_USERS',
  CLEAR_RETAILER_USERS: 'CLEAR_RETAILER_USERS',
  RECEIVE_ERR_RETAILER_USERS: 'RECEIVE_ERR_RETAILER_USERS',

  REQUEST_ORDER_DETAILS: 'REQUEST_ORDER_DETAILS',
  REQUEST_ORDER_DETAILS_SAGA: 'REQUEST_ORDER_DETAILS_SAGA',
  RECEIVE_ORDER_DETAILS: 'RECEIVE_ORDER_DETAILS',
  RECEIVE_ORDER_DETAILS_SAGA: 'RECEIVE_ORDER_DETAILS_SAGA',
  RECEIVE_ERR_ORDER_DETAILS: 'RECEIVE_ERR_ORDER_DETAILS',
  RESET_ORDER_DETAILS: 'RESET_ORDER_DETAILS',
  CLEAR_ORDER_DETAILS: 'CLEAR_ORDER_DETAILS',
  CLEAR_ORDER_DETAILS_SAGA: 'CLEAR_ORDER_DETAILS_SAGA',
  CLEAR_VALIDATION: 'CLEAR_VALIDATION',
  CANCEL_ORDER_SAGA: 'CANCEL_ORDER_SAGA',
  UPDATE_ORDER_PAYMENT_SAGA: 'UPDATE_ORDER_PAYMENT_SAGA',
  MARK_AS_UNPAID_SAGA: 'MARK_AS_UNPAID_SAGA',
  UPDATE_ORDER_SAGA: 'UPDATE_ORDER_SAGA',
  UPDATE_ORDER_PROPERTIES_SAGA: 'UPDATE_ORDER_PROPERTIES_SAGA',
  GENERATE_INVOICE_SAGA: 'GENERATE_INVOICE_SAGA',
  DISPATCH_ORDER: 'DISPATCH_ORDER',
  ORDER_REQUEST_END: 'ORDER_REQUEST_END',

  CREATE_RETAILER_USER: 'CREATE_RETAILER_USER',
  CREATE_RETAILER_USER_SUCCESS: 'CREATE_RETAILER_USER_SUCCESS',
  CREATE_RETAILER_USER_FAILURE: 'CREATE_RETAILER_USER_FAILURE',

  CLEAR_EVENTS_SAGA: 'CLEAR_EVENTS_SAGA',
  FETCH_EVENTS_SAGA: 'FETCH_EVENTS_SAGA',

  // ***********************************************************************************
  // VISIBILITY GROUPS

  CREATE_VISIBILITY_GROUP_REQUEST: 'CREATE_VISIBILITY_GROUP_REQUEST',
  CREATE_VISIBILITY_GROUP_SUCCESS: 'CREATE_VISIBILITY_GROUP_SUCCESS',
  CREATE_VISIBILITY_GROUP_FAILURE: 'CREATE_VISIBILITY_GROUP_FAILURE',

  // ***********************************************************************************
  // VISIBILITY GROUPS NEW
  SAVE_VISIBILITY_GROUP_NEW_NAME: 'SAVE_VISIBILITY_GROUP_NEW_NAME',
  PROCEED_VISIBILITY_GROUP_STEP: 'PROCEED_VISIBILITY_GROUP_STEP',
  UPDATE_VISIBILITY_GROUP_STEP: 'UPDATE_VISIBILITY_GROUP_STEP',
  REQUEST_VISIBILITY_GROUP_NAME_SEARCH: 'REQUEST_VISIBILITY_GROUP_NAME_SEARCH',
  RECEIVE_VISIBILITY_GROUP_NAME_SEARCH_RES:
    'RECEIVE_VISIBILITY_GROUP_NAME_SEARCH_RES',
  ADD_TO_UNSELECTED_PRODUCTS_VISIBILITY_GROUP:
    'ADD_TO_UNSELECTED_PRODUCTS_VISIBILITY_GROUP',
  REMOVE_FROM_UNSELECTED_PRODUCTS_VISIBILITY_GROUP:
    'REMOVE_FROM_UNSELECTED_PRODUCTS_VISIBILITY_GROUP',
  ADD_RETAILER_TO_VISIBILITY_GROUP: 'ADD_RETAILER_TO_VISIBILITY_GROUP',
  REMOVE_RETAILER_FROM_VISIBILITY_GROUP:
    'REMOVE_RETAILER_FROM_VISIBILITY_GROUP',
  SAVE_INDIVIDUAL_VISIBILITY_GROUP_NEW: 'SAVE_INDIVIDUAL_VISIBILITY_GROUP_NEW',

  FETCH_VISIBILITY_GROUP_DETAILS_REQUEST:
    'FETCH_VISIBILITY_GROUP_DETAILS_REQUEST',
  RECEIVE_VISIBILITY_GROUP_DETAILS_SUCCESS:
    'RECEIVE_VISIBILITY_GROUP_DETAILS_SUCCESS',
  RECEIVE_VISIBILITY_GROUP_DETAILS_ERROR:
    'RECEIVE_VISIBILITY_GROUP_DETAILS_ERROR',

  // ***********************************************************************************
  // SIGNUP WIDGET
  REQUEST_SIGNUP_DETAILS: 'REQUEST_SIGNUP_DETAILS',
  RECEIVE_SIGNUP_DETAILS: 'RECEIVE_SIGNUP_DETAILS',
  RECEIVE_ERR_SIGNUP_DETAILS: 'RECEIVE_ERR_SIGNUP_DETAILS',

  // ***********************************************************************************
  // VISIBILITY GROUP RETAILERS
  REQUEST_VISIBILITY_RETAILERS: 'REQUEST_VISIBILITY_RETAILERS',
  RECEIVE_VISIBILITY_RETAILERS: 'RECEIVE_VISIBILITY_RETAILERS',
  RECEIVE_ERR_VISIBILITY_RETAILERS: 'RECEIVE_ERR_VISIBILITY_RETAILERS',

  REQUEST_DATA_INVITATION_VISIBILITY_GROUPS:
    'REQUEST_DATA_INVITATION_VISIBILITY_GROUPS',
  RECEIVE_DATA_INVITATION_VISIBILITY_GROUPS:
    'RECEIVE_DATA_INVITATION_VISIBILITY_GROUPS',

  REQUEST_SUPPLIER_VISIBILITY_GROUPS: 'REQUEST_SUPPLIER_VISIBILITY_GROUPS',
  RECEIVE_SUPPLIER_VISIBILITY_GROUPS: 'RECEIVE_SUPPLIER_VISIBILITY_GROUPS',
  RECEIVE_SUPPLIER_VISIBILITY_GROUPS_PAGINATED:
    'RECEIVE_SUPPLIER_VISIBILITY_GROUPS_PAGINATED',
  RECEIVE_ERR_SUPPLIER_VISIBILITY_GROUPS:
    'RECEIVE_ERR_SUPPLIER_VISIBILITY_GROUPS',
  RESET_VISIBILITY_GROUPS: 'RESET_VISIBILITY_GROUPS',
  UPDATE_LAST_FETCHED_VISIBILITY_GROUPS_PAGE:
    'UPDATE_LAST_FETCHED_VISIBILITY_GROUPS_PAGE',
  // ***********************************************************************************
  // SCHEDULES
  REQUEST_SUPPLIER_SCHEDULES: 'REQUEST_SUPPLIER_SCHEDULES',
  RECEIVE_SUPPLIER_SCHEDULES: 'RECEIVE_SUPPLIER_SCHEDULES',
  RECEIVE_SUPPLIER_SCHEDULES_PAGINATED: 'RECEIVE_SUPPLIER_SCHEDULES_PAGINATED',
  RECEIVE_ERR_SUPPLIER_SCHEDULES: 'RECEIVE_ERR_SUPPLIER_SCHEDULES',
  ADD_CURRENT_SCHEDULE: 'ADD_CURRENT_SCHEDULE',
  FETCH_SCHEDULE_DETAILS_REQUEST: 'FETCH_SCHEDULE_DETAILS_REQUEST',
  RECEIVE_SCHEDULE_DETAILS_SUCCESS: 'RECEIVE_SCHEDULE_DETAILS_SUCCESS',
  RECEIVE_SCHEDULE_DETAILS_ERROR: 'RECEIVE_SCHEDULE_DETAILS_ERROR',
  FETCH_SCHEDULE_RETAILERS_REQUEST: 'FETCH_SCHEDULE_RETAILERS_REQUEST',
  RECEIVE_SCHEDULE_RETAILERS_SUCCESS: 'RECEIVE_SCHEDULE_RETAILERS_SUCCESS',
  RECEIVE_SCHEDULE_RETAILERS_ERROR: 'RECEIVE_SCHEDULE_RETAILERS_ERROR',
  CREATE_SCHEDULE_RETAILER_REQUEST: 'CREATE_SCHEDULE_RETAILER_REQUEST',
  RECEIVE_CREATE_SCHEDULE_RETAILER_SUCCESS:
    'RECEIVE_CREATE_SCHEDULE_RETAILER_SUCCESS',
  RECEIVE_CREATE_SCHEDULE_RETAILER_ERROR:
    'RECEIVE_CREATE_SCHEDULE_RETAILER_ERROR',
  DELETE_SCHEDULE_RETAILER_REQUEST: 'DELETE_SCHEDULE_RETAILER_REQUEST',
  RECEIVE_DELETE_SCHEDULE_RETAILER_REQUEST:
    'RECEIVE_DELETE_SCHEDULE_RETAILER_REQUEST',
  RECEIVE_DELETE_SCHEDULE_RETAILER_SUCCESS:
    'RECEIVE_DELETE_SCHEDULE_RETAILER_SUCCESS',
  RECEIVE_DELETE_SCHEDULE_RETAILER_ERROR:
    'RECEIVE_DELETE_SCHEDULE_RETAILER_ERROR',
  ADD_RETAILER_TO_SCHEDULE_GROUP_UI: 'ADD_RETAILER_TO_SCHEDULE_GROUP_UI',
  REMOVE_RETAILER_FROM_SCHEDULE_GROUP_UI:
    'REMOVE_RETAILER_FROM_SCHEDULE_GROUP_UI',
  RESET_DATA_SCHEDULE_RETAILERS: 'RESET_DATA_SCHEDULE_RETAILERS',

  RESET_EXCLUDED_SCHEDULE_RETAILERS: 'RESET_EXCLUDED_SCHEDULE_RETAILERS',
  RESET_INCLUDED_SCHEDULE_RETAILERS: 'RESET_INCLUDED_SCHEDULE_RETAILERS',
  RESET_SUPPLIER_SCHEDULES: 'RESET_SUPPLIER_SCHEDULES',
  UPDATE_LAST_FETCHED_SUPPLIER_SCHEDULES_PAGE:
    'UPDATE_LAST_FETCHED_SUPPLIER_SCHEDULES_PAGE',

  ADD_FAVOURITE_REQUEST: 'ADD_FAVOURITE_REQUEST',
  ADD_FAVOURITE_SUCCESS: 'ADD_FAVOURITE_SUCCESS',
  ADD_FAVOURITE_ERROR: 'ADD_FAVOURITE_ERROR',
  // ***********************************************************************************
  // NEXT RUN CALCULATION
  FETCH_SCHEDULE_NEXT_RUN_REQUEST: 'FETCH_SCHEDULE_NEXT_RUN_REQUEST',
  FETCH_SCHEDULE_NEXT_RUN_SUCCESS: 'FETCH_SCHEDULE_NEXT_RUN_SUCCESS',
  FETCH_SCHEDULE_NEXT_RUN_ERROR: 'FETCH_SCHEDULE_NEXT_RUN_ERROR',

  // ***********************************************************************************
  // GLOBAL SEARCH
  REQUEST_GLOBAL_SEARCH: 'REQUEST_GLOBAL_SEARCH',
  GLOBAL_SEARCH_FOCUS: 'GLOBAL_SEARCH_FOCUS',

  REQUEST_GLOBAL_ORDERS: 'REQUEST_GLOBAL_ORDERS',
  RECEIVE_GLOBAL_ORDERS_SUCCESS: 'RECEIVE_GLOBAL_ORDERS_SUCCESS',
  RECEIVE_GLOBAL_ORDERS_ERROR: 'RECEIVE_GLOBAL_ORDERS_ERROR',

  REQUEST_GLOBAL_INVOICES: 'REQUEST_GLOBAL_INVOICES',
  RECEIVE_GLOBAL_INVOICES_SUCCESS: 'RECEIVE_GLOBAL_INVOICES_SUCCESS',
  RECEIVE_GLOBAL_INVOICES_ERROR: 'RECEIVE_GLOBAL_INVOICES_ERROR',

  REQUEST_GLOBAL_PURCHASERS: 'REQUEST_GLOBAL_PURCHASERS',
  RECEIVE_GLOBAL_PURCHASERS_SUCCESS: 'RECEIVE_GLOBAL_PURCHASERS_SUCCESS',
  RECEIVE_GLOBAL_PURCHASERS_ERROR: 'RECEIVE_GLOBAL_PURCHASERS_ERROR',

  FETCH_GLOBAL_PRODUCTS_REQUEST: 'FETCH_GLOBAL_PRODUCTS_REQUEST',
  RECEIVE_GLOBAL_PRODUCTS_SUCCESS: 'RECEIVE_GLOBAL_PRODUCTS_SUCCESS',
  RECEIVE_GLOBAL_PRODUCTS_ERROR: 'RECEIVE_GLOBAL_PRODUCTS_ERROR',

  SEARCH_STARTED: 'SEARCH_STARTED',
  SEARCH_RESULTS_SELECTED: 'SEARCH_RESULTS_SELECTED',

  // ***********************************************************************************
  // BULK ACTIONS
  RETAILER_BULK_UPDATE_REQUEST: 'RETAILER_BULK_UPDATE_REQUEST',
  RETAILER_BULK_UPDATE_SUCCESS: 'RETAILER_BULK_UPDATE_SUCCESS',
  RETAILER_BULK_UPDATE_ERROR: 'RETAILER_BULK_UPDATE_ERROR',

  // ***********************************************************************************
  // DOWNLOADS
  REQUEST_DOWNLOADS: 'REQUEST_DOWNLOADS',
  RECEIVE_DOWNLOADS: 'RECEIVE_DOWNLOADS',
  RECEIVE_ERR_DOWNLOADS: 'RECEIVE_ERR_DOWNLOADS',

  // ***********************************************************************************
  // RESTART DOWNLOADS
  REQUEST_RESTART_DOWNLOAD: 'REQUEST_RESTART_DOWNLOAD',
  RECEIVE_RESTART_DOWNLOAD: 'RECEIVE_RESTART_DOWNLOAD',
  RECEIVE_ERR_RESTART_DOWNLOAD: 'RECEIVE_ERR_RESTART_DOWNLOAD',

  // ***********************************************************************************
  // OTHER CONSTANTS
  NOTIFY_COPIED_TO_CLIPBOARD: 'NOTIFY_COPIED_TO_CLIPBOARD',

  PAYMENT_METHOD_TYPE_OPTIONS: ['Card', 'Direct', 'Other'],

  INVOICE_SCHEDULE_SETTING_OPTIONS: ['Invoice', 'Statement'],

  INVOICE_DATE_OPTIONS: {
    on_delivery: 'On delivery',
    on_placement: 'On placement',
  },

  FREIGHT_STATE_OPTIONS: [
    { text: 'National', value: 'national' },
    { text: 'NSW', value: 'nsw' },
    { text: 'QLD', value: 'qld' },
    { text: 'NT', value: 'nt' },
    { text: 'SA', value: 'sa' },
    { text: 'TAS', value: 'tas' },
    { text: 'VIC', value: 'vic' },
    { text: 'WA', value: 'wa' },
    { text: 'ACT', value: 'act' },
  ],

  FREIGHT_TYPE_OPTIONS: [
    { text: 'Metro', value: 'metro' },
    { text: 'Standard', value: 'standard' },
    { text: 'Express', value: 'express' },
    { text: 'Courier', value: 'courier' },
    { text: 'Other', value: 'other' },
  ],

  AUST_STATES: ['NSW', 'VIC', 'QLD', 'ACT', 'SA', 'WA', 'NT', 'TAS'],

  SCHEDULE_FREQUENCY_OPTIONS: [
    { text: 'Daily', value: 'daily' },
    // { text: 'Fortnightly', value: 'fortnightly' },
    { text: 'Weekly', value: 'weekly' },
    { text: 'Monthly', value: 'monthly' },
  ],

  SCHEDULE_WEEKDAY_OPTIONS: [
    { text: 'Monday', value: '0' },
    { text: 'Tuesday', value: '1' },
    { text: 'Wednesday', value: '2' },
    { text: 'Thursday', value: '3' },
    { text: 'Friday', value: '4' },
  ],

  SCHEDULE_WEEKEND_OPTIONS: [
    { text: 'Saturday', value: '5' },
    { text: 'Sunday', value: '6' },
  ],

  DAY_MAP: [
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
    'Sunday',
  ],

  EXPORT_TYPES: {
    orders: {
      orders_export_csv: {
        tag: 'orders_export_csv',
        label: 'Orders (CSV)',
        propertyName: 'ordersCsv',
      },
      orders_line_items_export_csv: {
        tag: 'orders_line_items_export_csv',
        label: 'Line Items (CSV)',
        propertyName: 'ordersLineItemsCsv',
      },
      orders_line_items_export_tsv: {
        tag: 'orders_line_items_export_tsv',
        label: 'Line Items (TSV)',
        propertyName: 'ordersLineItemsTsv',
      },
      line_items_per_order_export_csv: {
        tag: 'line_items_per_order_export_csv',
        label: 'Line Items per Order (ZIP)',
        propertyName: 'lineItemsPerOrderCsv',
      },
      orders_production_export_csv: {
        tag: 'orders_production_export_csv',
        label: 'Product Tally (CSV)',
        propertyName: 'ordersProductionCsv',
      },
      orders_cogs_export_csv: {
        tag: 'orders_cogs_export_csv',
        label: 'Orders COGS (CSV)',
        propertyName: 'ordersCOGSExportCSV',
      },
      orders_production_report_sumo_csv: {
        tag: 'orders_production_report_sumo_csv',
        label: 'Production Report (Sumo)',
        propertyName: 'ordersProductionReportSumoCsv',
      },
      orders_production_report_little_bertha_csv: {
        tag: 'orders_production_report_little_bertha_csv',
        label: 'Production Report (Little Bertha)',
        propertyName: 'ordersProductionReportLittleBerthaCsv',
      },
      orders_production_report_my_butcher_csv: {
        tag: 'orders_production_report_my_butcher_csv',
        label: 'Production Report (My Butcher)',
        propertyName: 'ordersProductionReportMyButcherCsv',
      },
      orders_production_export_with_properties_csv: {
        tag: 'orders_production_export_with_properties_csv',
        label: 'Product Tally With Properties (CSV)',
        propertyName: 'ordersProductionWithPropertiesCsv',
      },
      global_bake_export_xml: {
        tag: 'global_bake_export_xml',
        label: 'Global Bake (XML)',
        propertyName: 'globalBakeXml',
      },
      reckon_report: {
        tag: 'reckon_report',
        label: 'Reckon Report (IIF)',
        propertyName: 'reckonReport',
      },
      attache_xml: {
        tag: 'attache_xml',
        label: 'Attaché (XML)',
        propertyName: 'attacheXml',
      },
      pick_pdf: {
        tag: 'pick_pdf',
        label: 'Pick Slip (PDF)',
        propertyName: 'ordersPickPdf',
      },
      delivery_pdf: {
        tag: 'delivery_pdf',
        label: 'Delivery Slip (PDF)',
        propertyName: 'ordersDeliveryPdf',
      },
      invoice_pdf: {
        tag: 'invoice_pdf',
        label: 'Invoices (PDF)',
        propertyName: 'ordersInvoicePdf',
      },
      orders_delivery_manifest_pdf: {
        tag: 'orders_delivery_manifest_pdf',
        label: 'Delivery Manifest (PDF)',
        propertyName: 'ordersDeliveryManifestPdf',
      },
      orders_delivery_summary_pdf: {
        tag: 'orders_delivery_summary_pdf',
        label: 'Delivery Summary (PDF)',
        propertyName: 'ordersDeliverySummaryPdf',
      },
      orders_production_report_pdf: {
        tag: 'orders_production_report_pdf',
        label: 'Product Tally (PDF)',
        propertyName: 'ordersProductionReportPdf',
      },
      product_tally_by_customer_pdf: {
        tag: 'product_tally_by_customer_pdf',
        label: 'Product Tally by Customer (PDF)',
        propertyName: 'productTallyByCustomerPdf',
      },
    },
    invoices: {
      global_bake_invoice_export_xml: {
        tag: 'global_bake_invoice_export_xml',
        label: 'Global Bake (XML)',
        propertyName: 'globalBakeInvoiceXml',
      },
      invoice_summary_export_csv: {
        tag: 'invoice_summary_export_csv',
        label: 'Invoice Summary (CSV)',
        propertyName: 'invoiceSummaryCsv',
      },
    },
    retailers: {
      orders_forecast_export_csv: {
        tag: 'orders_forecast_export_csv',
        label: 'Upcoming Order Report (CSV)',
        propertyName: 'ordersForecastCsv',
      },
      retailers_export_csv: {
        tag: 'retailers_export_csv',
        label: 'Retailers (CSV)',
        propertyName: 'retailersCsv',
      },
      retailers_export_with_properties_csv: {
        tag: 'retailers_export_with_properties_csv',
        label: 'Retailers With Properties (CSV)',
        propertyName: 'retailersWithPropertiesCsv',
      },
      retailers_users_export_csv: {
        tag: 'retailers_users_export_csv',
        label: 'Retailer Users (CSV)',
        propertyName: 'retailersUsersCsv',
      },
      upcoming_orders_export_csv: {
        tag: 'upcoming_orders_export_csv',
        label: 'Upcoming Order Report (NEW) (CSV)',
        propertyName: 'upcomingOrdersCsv',
      },
    },
    products: {
      products_export_csv: {
        tag: 'products_export_csv',
        label: 'Products (CSV)',
        propertyName: 'productsCsv',
      },
      prices_csv: {
        tag: 'prices_csv',
        label: 'Product Prices (CSV)',
        propertyName: 'pricesCsv',
      },
    },
  },

  // API URLs
  API_BASE_URL: process.env.API_BASE_URL || 'http://localhost:3001',
  IMAGE_URL: process.env.IMAGE_URL || 'http://localhost:3001',

  // PROJECTIONS
  PROJECTIONS_URL: process.env.PROJECTIONS_URL || 'http://localhost:7778',
  PROJECTIONS_TOKEN:
    process.env.PROJECTIONS_TOKEN || 'wontYouTakeMeToFunkyTown',

  // INSIGHTS
  DOCUMENTUM_URL: process.env.DOCUMENTUM_URL || 'http://localhost:5522',

  // FLAGS
  FLAGS_URL: process.env.FLAGS_URL || 'http://localhost:6446',
  FLAGS_KEY: process.env.FLAGS_KEY || 'stale_aardvark_tarnish_regulate_nash',

  AUTH_URL: process.env.AUTH_URL || 'http://localhost:3006',

  // INSIGHTS
  VENUE_INSIGHTS_URL: process.env.VENUE_INSIGHTS_URL || 'http://localhost:8007',

  // CHAT
  CHAT_URL: process.env.CHAT_URL || 'http://localhost:8005',
  CHAT_WS_URL: process.env.CHAT_WS_URL || 'ws://localhost:8005',

  // Completion service
  COMPLETION_URL: process.env.COMPLETION_URL || 'http://localhost:18740',

  // PAYMENTS
  PAYMENTS_URL: process.env.PAYMENTS_URL || 'http://localhost:4000',
  PAYMENTS_USERNAME: process.env.PAYMENTS_USERNAME || 'test',
  PAYMENTS_PASSWORD: process.env.PAYMENTS_PASSWORD || 'pass',

  // REWARDS
  REWARDS_URL: process.env.REWARDS_URL || 'http://localhost:4431',

  // XERO
  XERO_URL: process.env.XERO_URL || 'http://localhost:4320',

  // SENTRY
  SENTRY_DSN: process.env.SENTRY_DSN || '',

  // NOTIFICATION TIMER
  NOTIFICATION_DELAY: 3000,

  // NOTIFICATION DELAY FOR PRODUCT IMPORTS
  PRODUCT_IMPORT_NOTIFICATION_DELAY: 300000,

  ORDER_PAID_STATUS: 'Paid',

  TABLET_BREAKPOINT: 1024,
  MOBILE_BREAKPOINT: 480,

  // PAGINATION
  DEFAULT_NUM_BLOCKS: 7,
  PAGE_SIZE_OPTIONS: [
    { value: 10, text: 10 },
    { value: 25, text: 25 },
    { value: 50, text: 50 },
    { value: 100, text: 100 },
    { value: 200, text: 200 },
    { value: 500, text: 500 },
  ],

  DEFAULT_MIN_PAGE_SIZE: 25,
  DEFAULT_PAGE_SIZE: 50,
  DEFAULT_PAGE_NO: 1,

  GLOBAL_SEARCH_NUM_RESULTS: 5,

  GROUP_UNASSIGNED: 'Unassigned',
  PROPERTY_UNASSIGNED: '–',

  SET_SOCKET_ID: 'SET_SOCKET_ID',

  MIXPANEL_TOKEN:
    process.env.MIXPANEL_TOKEN || '9da3b44f1ced2f36859c8e50ba57d859',

  // UPLOAD DEFAULTS
  LOGO_MAX_FILE_SIZE: 4 * 1000 * 1024,
  IMAGES_MAX_FILE_SIZE: 20 * 1000 * 1024,
  CSV_MAX_FILE_SIZE: 50 * 1000 * 1024,

  // TEST HELPERS
  NOOP: () => {},

  // NO_DELIVERY DATE
  NO_DELIVERY_DATE: 'TBA',

  BROWSER_TZ: Intl.DateTimeFormat().resolvedOptions().timeZone,

  // ORDER TYPES (7)
  STANDING_ORDER_NEW: 'standing-order-new',
  STANDING_ORDER_EDIT: 'standing-order-edit',
  STANDING_ORDER_EDIT_ALL: 'standing-order-edit-all',
  STANDING_ORDER_CANCEL: 'standing-order-cancel',
  ORDER_NEW: 'order-new',
  ORDER_EDIT: 'order-edit',
  DUPLICATE_ORDER: 'duplicate-order',
  FORWARD_ORDER_NEW: 'forward-order-new',

  // DATE PICKER
  DATE_PICKER_FORMAT: 'DD/MM/YYYY',

  // PRODUCT IMPORT CSV LOCATION
  PRODUCT_IMPORT_CSV_TEMPLATE:
    'https://static.ordermentum.com/supplier/product_import_template.csv',

  /* --- DATES ------------------------ */
  TIMESTAMP_FORMAT: 'ddd Do hh:mm A',

  /* --- PAYMENT METHODS ------------------------ */
  PAYMENT_METHOD_TYPES: [
    { display: 'Card', tag: 'card' },
    { display: 'Direct', tag: 'direct' },
    { display: 'Other', tag: 'other' },
  ],
  PAYMENT_METHOD_CARD: 'card',
  PAYMENT_METHOD_DIRECT: 'direct',
  PAYMENT_METHOD_CARD_AND_DIRECT: 'card_and_direct',
  PAYMENT_METHOD_OTHER: 'other',
  VALID_DIRECT_PAYMENT_TYPES: ['direct', 'card_and_direct'],
  VALID_CARD_PAYMENT_TYPES: ['card', 'card_and_direct'],

  // Payment
  EDIT_PAYMENT_CARD_DETAILS: 'edit_payment_details_card',
  REMOVE_PAYMENT_CARD_DETAILS: 'remove_payment_card_details',

  // GROWTH ENGINE
  LOADED_PAGE_GROWTH_ENGINE: 'LOADED_PAGE_GROWTH_ENGINE',
  MANAGE_GROWTH_ENGINE_REQUEST: 'MANAGE_GROWTH_ENGINE_REQUEST',
  ACCEPT_AND_START_TRADING: 'ACCEPT_AND_START_TRADING',
  REJECT_GROWTH_ENGINE_REQUEST: 'REJECT_GROWTH_ENGINE_REQUEST',
  FETCH_GROWTH_ENGINE_REQUESTS: 'FETCH_GROWTH_ENGINE_REQUESTS',
  FETCH_GROWTH_ENGINE_REQUESTS_REQUEST: 'FETCH_GROWTH_ENGINE_REQUESTS_REQUEST',
  FETCH_GROWTH_ENGINE_REQUESTS_SUCCESS: 'FETCH_GROWTH_ENGINE_REQUESTS_SUCCESS',
  FETCH_GROWTH_ENGINE_REQUESTS_ERROR: 'FETCH_GROWTH_ENGINE_REQUESTS_ERROR',

  // SUBSCRIPTION
  READ_SUBSCRIPTION_REQUEST: 'READ_SUBSCRIPTION_REQUEST',
  READ_SUBSCRIPTION_SUCCESS: 'READ_SUBSCRIPTION_SUCCESS',
  READ_SUBSCRIPTION_ERROR: 'READ_SUBSCRIPTION_ERROR',

  // EVENTS
  BUTTON_CLICKED: 'BUTTON_CLICKED',

  LITE: 'lite',
});
